var map = {
	"./action_selected.svg": 7380,
	"./add_order.svg": 2815,
	"./bianji.svg": 6713,
	"./dagl_weixuanzhong.svg": 6565,
	"./del.svg": 5714,
	"./home.svg": 7744,
	"./statements.svg": 9842,
	"./tenant.svg": 3418,
	"./tianjia.svg": 6135,
	"./xiangqing.svg": 3749,
	"./xiugai.svg": 6975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;